import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../utlils/axios";
import { dispatch } from "../index"
import { handleSnackbar } from "../../utlils/snackbar";
import { setLoading } from "../slices/fieldReducer"


export interface RecommendationState {
    recommendationId: string;
    recommendationMessage: string;
    acknowledged: boolean;
    status: string;
    remarks: string;
}

interface StateValue {
    recommendationData: RecommendationState[]
    updateRecommendationData: RecommendationState[]
}

const initialState: StateValue = {
    recommendationData: [],
    updateRecommendationData: []
}

const recommendationSlice = createSlice({
    name: "recommendation",
    initialState,
    reducers: {
        getRecommendationDetailsValue(state, action) {
            state.recommendationData = action.payload
        },
        updateRecommendationDetailsValue(state, action) {
            state.updateRecommendationData = action.payload
        },
        // Inside recommendationSlice.actions
        clearRecommendationDetails: (state) => {
            state.recommendationData = [];
        },
    }
})

export default recommendationSlice.reducer

// Export the actions so you can use them
export const {
    clearRecommendationDetails
} = recommendationSlice.actions;

//Get Recommendation Details
export const getRecommendationDetails = (modelCode: string, logDate: string) => {
    return async () => {
        dispatch(recommendationSlice.actions.clearRecommendationDetails());
        dispatch(setLoading(true));
        const url = `/de/recommendation-list/${logDate}/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(recommendationSlice.actions.getRecommendationDetailsValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        } finally {
            dispatch(setLoading(false));
        }
    }
}

// Update Recommendation Details
export const updateRecommendationDetails = (payload: any, modelCode: string, logDate: string) => {
    return async () => {
        const url = `/de/recommendation-data/${logDate}/${modelCode}`
        try {
            const response = await axios.put(url, payload)
            dispatch(recommendationSlice.actions.updateRecommendationDetailsValue(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}